export enum ContentGridSelectMode {
  OFF,
  SINGLE,
  MULTIPLE,
}